export * from "./tile.component";
